import { WidgetType } from '@ael/core-api';
import {WidgetDataResponse} from './widgetDataRepository';

export class WidgetDataCache {
  _cache: Map<string, WidgetDataResponse>;
  constructor() {
    this._cache = new Map<string, WidgetDataResponse>();
  }

  private _cacheHas = (body: Key) => {
    return this._cache.has(body.serialize());
  };

  private _cacheGet = (body: Key) => {
    return this._cache.get(body.serialize());
  };

  private _cacheSet = (body: Key, newResponse: WidgetDataResponse) => {
    return this._cache.set(body.serialize(), newResponse);
  };

  tryGetDataForWidget = async (
    widgetType: WidgetType,
    requestBody: string,
    fetchMethod: () => Promise<WidgetDataResponse>
  ): Promise<WidgetDataResponse> => {
    const key = new Key(widgetType, requestBody);
    if (this._cacheHas(key)) {
      const cachedValue = this._cacheGet(key);
      return Promise.resolve(cachedValue);
    }

    const freshValue = await fetchMethod();
    this._cacheSet(key, freshValue);
    return freshValue;
  };
}

class Key {
  private readonly _requestBody: string;
  private readonly _widgetType: WidgetType;
  constructor(widgetType: WidgetType, requestBody: string) {
    this._widgetType = widgetType;
    this._requestBody = requestBody;
  }

  serialize = () => `${this._widgetType}+${this._requestBody}`;

  equals(another: Key): boolean {
    return this._requestBody === another._requestBody && this._widgetType === another._widgetType;
  }
}
